export const SALE_PRICE_PARAMS = {
  oil: { name: "Oil_Sale", axisName: 'Oil', unit: "$/bbl" },
  gas: { name: "NG_Sale", axisName: 'Gas', unit: "$/MSCF" },
  oil_history: { name: 'WTI Oil', unit: '$/bbl' },
  gas_history: { name: 'Henry Hub Gas', unit: '$/MSCF' },
  ngl: { name: 'NGL_Sale', axisName: 'NGL', unit: '$/gln' }
};